<template>
  <button
    type="button"
    class="btn c-btn"
    :class="[
      `c-btn-${mode}`,
      {
        'btn-primary': mode === 'primary',
        'btn-outline-primary primary-text': mode === 'transparent'
      }
    ]"
    @click="$emit('action', $event)"
    :disabled="disabled"
  >
    <i :class="getArrow()"></i>
  </button>
</template>

<script>
export default {
  name: "RoundedButton",
  props: ["type", "disabled", "mode"],
  methods: {
    getArrow() {
      console.log("entrato");
      const types = {
        next: "fa fa-arrow-right",
        down: "far fa-arrow-down",
        prev: "far fa-arrow-left",
        up: "far fa-arrow-up",
        check: "fas fa-check",
        controlla: "fas fa-check",
        prossimo: "fa fa-arrow-right",
        prossima: "fa fa-arrow-right"
      };
      console.log("entrato", this.type);
      return types[this.type];
    }
  }
};
</script>

<style lang="scss" scoped>
.c-btn {
  border-radius: 50%;
  padding: 13px 18px;
}
</style>
